export default {
    path: 'community',
    component: () => import('../Community.vue'),
    children: [
        {
            path: '',
            name: 'Cộng đồng',
            component: () => import('../table/Table.vue')
        },
        // {
        //     path: 'cu',
        //     name: 'Tạo Bài viết',
        //     component: () => import('../cu/CU.vue'),
        // },
        // {
        //     path: 'cu/:id',
        //     name: 'Chỉnh sửa Bài viết',
        //     component: () => import('../cu/CU.vue'),
        // },
    ]
};